module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Devices/Homepod-c8eff78476d95fbf550d94e308d6a9af.svg";